import React from "react";
import { Create } from "react-admin";
import { useTranslate } from "react-admin";
import RuleDeemedSupplierForm from "./RuleDeemedSupplierForm";
import { transformData } from "./Services/rulesDeemedSupplierServices";

const RuleDeemedSupplierCreate: React.FC = () => {
  const translate = useTranslate();

  return (
    <Create
      title={translate("rules.create.title")}
      redirect="list"
      transform={transformData}
    >
      <RuleDeemedSupplierForm />
    </Create>
  );
};

export default RuleDeemedSupplierCreate;
